import apiServiceAsync from '@/api/apiServiceAsync';

const api = await apiServiceAsync();
export default {
  getTemplates({ commit }) {
    return api.get('/api/v1/integration/pandadoc/template')
      .then((response) => {
        commit('setTemplates', response.data);
        return response.data;
      });
  },
  getDocumentStatus(state, documentId) {
    return api.get(`/api/v1/integration/pandadoc/document/${documentId}/check-draft-status`)
      .then((response) => response);
  },
  createDocumentFromTemplate(state, payload) {
    return api.post('/api/v1/integration/pandadoc/document/create', payload)
      .then((response) => response.data);
  },
  createDocumentEditingSessions(state, payload) {
    return api.post('/api/v1/integration/pandadoc/document/editing-sessions', payload)
      .then((response) => response.data);
  },
  downloadPandaDoc(state, documentId) {
    return api.get(`api/v1/integration/pandadoc/document/${documentId}/download`, { responseType: 'arraybuffer' })
      .then((response) => response.data);
  },
};
